import React, { useRef, useEffect, useState } from 'react';
import { Form, Input, Button, Col, Row, Spin } from 'antd';
import { user, updatePasssword } from 'services/login/login';
import { fetchMessageListAPI } from 'services/shared/fetchLovList';
import { useHistory } from 'react-router-dom';

import Message from 'shared_components/message';
import FIELD_RULES from './constants';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';

import auth from 'services/login/auth';

export default function ChangePassword(){
	const formRef = useRef();
    const navigate = useHistory();

    const [userData, setUserData] = useState([]);
    const [oldPass, setOldPass] = useState(false);
    const [newPass, setNewPass] = useState('');
    const [reTypePass, setReTypePass] = useState(false);
    const [reTypePassVal, setReTypePassVal] = useState('');
    const [ isloading, setLoading ] = useState(true);
    const [messagesList, setMessagesList] = useState([]);

    const loggedinUser = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));

    async function getLOVList(){
        try{
            const userRes = await user(loggedinUser.userID);
            const messages = await fetchMessageListAPI();

            setUserData(userRes);
            setMessagesList(messages);
            
            //test loader spin
            if(messages){
                setLoading(false);
            };
        }catch(error) {
            console.log(error);
        }
    };

    useEffect(()=> {
        getLOVList();
    }, []);

    function handleOldValue(e){
        // @ts-ignore
        if(e.target.value === userData.password){
            setOldPass(true);
        }else{
            setOldPass(false);
        }
    }

    function handleNewValue(e){
        const m0023 = messagesList.filter((items) => items.message_code === 'M0023');
        setNewPass(e.target.value);

        if (e.target.value.length > 5) {
            if(e.target.value !== '' && reTypePassVal !== ''){
                if(e.target.value === reTypePassVal){
                    setReTypePass(true);
                }else{
                    setReTypePass(false);
                }
            }
        }else{
            Message.error({ message: m0023[0].message_display });
            e.target.focus();
        }
    }

    function handleReTypeValue(e){
        setReTypePassVal(e.target.value);

        if(e.target.value === newPass){
            setReTypePass(true);
        }else{
            setReTypePass(false);
        }
    }

    async function handleSubmit(formValues) {

        const m0022 = messagesList.filter((items) => items.message_code === 'M0022');
        const m0023 = messagesList.filter((items) => items.message_code === 'M0023');
        const m0024 = messagesList.filter((items) => items.message_code === 'M0024');

        if(!oldPass){
            Message.error({ message: m0022[0].message_display });
        };

        if(!reTypePass){
            Message.error({ message: 'Re-typed password is not the same with the entered new password.' });
        };

        if(oldPass && reTypePass){
            // @ts-ignore
            const changePass = await updatePasssword(userData.user_id, formValues.new_password);
            if(changePass.user_id !== undefined){
                Message.success({ message: m0024[0].message_display });

                navigate.push('/home');
            }
        };
    };

    return isloading ? (
        <div className='spin-loading' >
            <Spin tip="Loading..." size='large'></Spin>
        </div>
    ) : (
        <div>
        <div className="login-form">
            {/* <div style={{ textAlign: 'center' }}>
                <img src={CompanyLogo} alt="logo" className="login-logo-image" />
            </div> */}
            <div>
                <h2>Change Password</h2>
            </div>
            <Form
                onFinish={handleSubmit}
                ref={formRef}
                layout="vertical"
            >
                <Form.Item 
                    name="old_password" 
                    label="Old Password" 
                    rules={FIELD_RULES.password}
                    validateTrigger={'onBlur'}
                >
                    <Input.Password type="password" maxLength={20} autoComplete='on' 
                        onBlur={handleOldValue}
                        onPressEnter={handleOldValue}
                    />
                </Form.Item>
                <Form.Item 
                    name="new_password" 
                    label="New Password" 
                    rules={FIELD_RULES.password}
                    validateTrigger={'onBlur'}
                >
                    <Input.Password type="password" maxLength={20} autoComplete='on'
                        onBlur={handleNewValue}
                        onPressEnter={handleNewValue}
                    />
                </Form.Item>						
                <Form.Item 
                    name="retype_password" 
                    label="Re-type New Password" 
                    rules={FIELD_RULES.password}
                    validateTrigger={'onBlur'}
                >
                    <Input.Password type="password" maxLength={20} autoComplete='on'
                        onBlur={handleReTypeValue}
                        onPressEnter={handleReTypeValue}
                    />
                </Form.Item>
                <Form.Item style={{ margin: '10px 0px' }}>
                    <Row>
                        <Col className="gutter-row" style={{ marginRight: 5 }}>
                            <Button
                                onClick={() => {auth.signout();}}
                            >
                                CANCEL
                            </Button>
                        </Col>
                        <Col className="gutter-row">
                            <Button
                                type="primary"
                                htmlType="submit" 
                                // className="login-form-button"
                            >
                                SAVE
                            </Button>
                        </Col>
                    </Row>
                </Form.Item>
            </Form>
        </div>
        </div>
    )
}